/**
 * WTS partner attribution helper — captures ?ref= into a 90-day cookie
 * and reads it back on signup. The cookie name is fixed by the WTS spec.
 *
 * Mount `captureWtsRefFromUrl()` once on every public landing page (App.js
 * already does this site-wide). Call `getWtsRef()` at signup-submit time.
 */
const COOKIE_NAME = 'wts_ref';
const COOKIE_DAYS = 90;

export function getWtsRef() {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(/(?:^|;\s*)wts_ref=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

export function setWtsRef(code) {
  if (typeof document === 'undefined' || !code) return;
  const expires = new Date(Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
  const sameSite = window.location.protocol === 'https:' ? 'None; Secure' : 'Lax';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(code)}; expires=${expires}; path=/; SameSite=${sameSite}`;
}

/**
 * Reads ?ref= from the current URL and stores it in the wts_ref cookie if present.
 * Safe to call repeatedly — last ?ref= wins (most-recent attribution).
 */
export function captureWtsRefFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && ref.trim()) {
      setWtsRef(ref.trim());
    }
  } catch {
    // no-op
  }
}
